
import "react-select/dist/react-select.css";
import "react-virtualized-select/styles.css";

import React, { Component } from 'react';
import { MenuItem, Menu, Button, Icon, Grid, TextField, Checkbox, ListItemText, Input } from '@material-ui/core';
import { connect } from 'react-redux';
import  {MCFilterDropdown}  from './Components/MCFilterDropdown';

// Dummy array of test values.
const options = Array.from(new Array(1000), (_, index) => ({
    label: `Item ${index}`,
    value: index
  }));


class MCFilterBarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
        clearable: true,
        disabled: false,
        githubUsers: [],
        multi: false,
        searchable: true,
        selectedCreatable: null,
        selectedCity: null
      }
  }

  handleChange = (event) => {
    this.setState({ name: event.target.value });
  }

  onHandleCategoryChange = (selectedOptions) => {
    console.log("onHandleCategoryChange",selectedOptions)
    if (this.props.onHandleCategoryChange) {
      this.props.onHandleCategoryChange(selectedOptions);
    }
  }

  onHandleBrandChange = (selectedOptions) => {
    console.log("onHandleBrandChange",selectedOptions)
    if (this.props.onHandleBrandChange) {
      this.props.onHandleBrandChange(selectedOptions);
    }
  }

  onApplyClick = () => {
    console.log("onApplyClick")
    if (this.props.onApplyClick) {
      this.props.onApplyClick();
    }
  }
  
   
  render() {
    const { masterCatalogReducer = {} } = this.props
    const {  selectedCity } = this.state

    console.log("selectedCity",selectedCity)
    return (
      <Grid className="filter-bar-container" style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '8px' }}>
        <Grid xs={6}  sm={4} md={7} lg={7} style={{width: '250px'}}>
        <MCFilterDropdown filterOptions={masterCatalogReducer && masterCatalogReducer.categories || []}
        placeHolderText="Select Categories" onHandleFilter={this.onHandleCategoryChange} {...this.props}/>
        </Grid>          
        <Grid xs={6}  sm={4} md={7} lg={7} style={{ paddingLeft: '10px' , width: '250px'}}>
        <MCFilterDropdown filterOptions={masterCatalogReducer && masterCatalogReducer.brands || []} 
            placeHolderText="Select Brands" onHandleFilter={this.onHandleBrandChange} {...this.props}/>
        </Grid>

        <Grid xs={6}  sm={4} md={7} lg={7} style={{ paddingLeft: '10px' , width: '250px'}}>
          <Button className="button-white-and-blue" 
                  onClick={this.onApplyClick}>
            <span className="button-text">Apply</span>
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export const MCFilterBar = connect(({ dispatch, masterCatalogReducer }) => ({
  dispatch,
  masterCatalogReducer,
}))(MCFilterBarComponent);


// WEBPACK FOOTER //
// ./src/components/MasterCatalog/MCFilterBar.js